import { render, staticRenderFns } from "./PromoProduct.vue?vue&type=template&id=1152e20a"
import script from "./PromoProduct.vue?vue&type=script&lang=js"
export * from "./PromoProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports